import { Skeleton } from '@etg/wings';
import { css } from '@eti/styles';

const iconOnlySkeletonStyles = css`
  height: 34px;
  width: 34px;
`;

const withLabelSkeletonStyles = css`
  height: 34px;
  width: 104px;
`;

interface SettingsSkeletonProps {
  iconOnly?: boolean;
}

const SettingsSkeleton = ({ iconOnly = false }: SettingsSkeletonProps) => (
  <Skeleton
    className={iconOnly ? iconOnlySkeletonStyles : withLabelSkeletonStyles}
    data-testid="settings-skeleton"
  />
);

export default SettingsSkeleton;
